import "./chunk-7B52C2XE.js";
class TransactionReviewError extends Error {
  constructor(transactionReviewUrl) {
    super("transaction review error");
    this.name = "TransactionReviewError";
    this.transactionReviewUrl = transactionReviewUrl;
  }
}
class TransactionReviewDenied extends Error {
  constructor() {
    super("transaction review has been denied by the user");
    this.name = "TransactionReviewDenied";
  }
}
class TransactionReviewTimeout extends Error {
  constructor(transactionReviewUrl, pendingTransactionId) {
    super("transaction review has timed out");
    this.name = "TransactionReviewTimeout";
    this.transactionReviewUrl = transactionReviewUrl;
    this.pendingTransactionId = pendingTransactionId;
  }
}
export {
  TransactionReviewDenied,
  TransactionReviewError,
  TransactionReviewTimeout
};
